//@ts-nocheck

import React from "react";

import * as S from "./ModalPhoto.styles";

import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import { SpacerBase } from "../../../atoms/GridSystem";
import Icon from "../../../atoms/Icon/Icon.component";
import Button from "../../../atoms/Button/Button.component";
import Image from "next/image";

import { useModal } from "../../../../contexts/Modal.context";

const ModalPhoto = ({
  title,
  image,
  aspectRatio
}: {
  title: string;
  image: {
    src: string;
    alt: string;
  };
  aspectRatio: string;
}) => {
  const { closeModal } = useModal();

  return (
    <S.ModalPhoto>
      <S.ModalPhotoIconWrapper
        onClick={() => {
          closeModal();
        }}
      >
        <Icon name="x-mark" />
      </S.ModalPhotoIconWrapper>
      <S.ModalPhotoContent>
        <S.ModalPhotoImageWrapper aspectRatio={aspectRatio}>
          <Image fill src={image.url} alt={image.alt} />
        </S.ModalPhotoImageWrapper>
        <SpacerBase xs={2} />
        <Heading content={title} typo="headingMD" />
      </S.ModalPhotoContent>
    </S.ModalPhoto>
  )
}

export default ModalPhoto